import {
    CONTRACTOR_PREFERENCES_REQUEST,
    CONTRACTOR_PREFERENCES_SUCCESS,
    CONTRACTOR_PREFERENCES_FAILURE
} from '../actions';

export const CONTRACTOR_PREFERENCES_INITIAL_STATE = {
    isFetching: false,
    data: [],
    error: null
};

const preferencesReducers = {
    [CONTRACTOR_PREFERENCES_REQUEST]: (state) => {
        return {...state, isFetching: true, error: null};
    },
    [CONTRACTOR_PREFERENCES_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null};
    },
    [CONTRACTOR_PREFERENCES_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    }
};

export default function preferences(state = CONTRACTOR_PREFERENCES_INITIAL_STATE, action) {
    let reducer = preferencesReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/contractor-preferences.js